<template>
  <div>
    <div class="page-header">
      <div class="row justify-content-end">
        <div class="col-10 text-left">
          <h2 class="page-title">{{$t('registration.tabs.tabPersonalDetails')}}</h2>
        </div>
        <div class="col-2 lighten text-right">
          <h2 class="page-title">17%</h2>
        </div>
      </div>
    </div>
    <form class="row justify-content-center p-details" action="POST" v-on:submit.prevent="save('form-1')" data-vv-scope="form-1">
      <div class="col-12">
        <div class="form-group custom-input">
          <div class="wrap-cb">
            <label class="c-wrap pad-left-35">{{$t('candidateProfile.personalDetails.msgScanAadhar')}}
              <input type="checkbox" checked="checked" v-model="scanAadhar">
              <span class="checkmark"></span>
            </label>
          </div>
          <br/>
          <div class="alert alert-success">
            <small>{{$t('candidateProfile.personalDetails.noteAadhar')}} </small>
          </div>
          <br/>
          <div v-if="scanAadhar">
            <div class="para" for="msg">{{$t('candidateProfile.personalDetails.lblAadhar')}} </div>
            <qrcode-reader @init="onInit" class="qrClass" @decode="onDecode" :video="{ facingMode: 'user' }"></qrcode-reader>
            <br/><br/>
          </div>
          <div class="para"> {{$t('candidateProfile.personalDetails.lblName')}}</div>
          <input name="FullName" class="form-control-alt uppercase col-4" id="fullname" v-model="personalDetail.fullName" v-validate="'required|alpha_spaces'" :class="{'form-error': errors.has('form-1.FullName'),'input': true, 'is-danger': errors.has('form-1.FullName') }" type="text" :placeholder="$t('candidateProfile.personalDetails.plceHoFullName')">
          <sup>
            <i class="mdi mdi-star text-danger"></i>
          </sup>
          <div class="para"> {{$t('candidateProfile.personalDetails.lblFatherName')}}   </div>
          <input name="Father Name" class="form-control-alt uppercase col-3" id="namefathername" v-model="personalDetail.fatherName" v-validate="'required|alpha_spaces'" :class="{'form-error': errors.has('form-1.Father Name'),'input': true, 'is-danger': errors.has('form-1.Father Name') }" type="text" :placeholder="$t('candidateProfile.personalDetails.plceFatherName')" >
          <sup>
            <i class="mdi mdi-star text-danger"></i>
          </sup>
          <div class="para"> {{$t('candidateProfile.personalDetails.lblMotherName')}}   </div>
          <input name="Mother Name" class="form-control-alt uppercase col-3" id="namemothername" v-model="personalDetail.motherName" v-validate="'required|alpha_spaces'" :class="{'form-error': errors.has('form-1.Mother Name'),'input': true, 'is-danger': errors.has('form-1.Mother Name') }" type="text" :placeholder="$t('candidateProfile.personalDetails.plceMotherName')" >
          <sup>
            <i class="mdi mdi-star text-danger"></i>
          </sup>
          <div class="para">{{$t('candidateProfile.personalDetails.lblGender')}} </div>
          <v-select label="name" :class="{'form-error': errors.has('gender')}" v-model="personalDetail.gender" :options="genderList" :error-messages="errors.collect('gender')" v-validate="'required|not_in:Select'" data-vv-name="gender" name="gender" :placeholder="$t('candidateProfile.personalDetails.plceHoGender')" required></v-select>
          <sup>
            <i class="mdi mdi-star text-danger"></i>
          </sup>
          <br/>
          <div class="para"> {{$t('candidateProfile.personalDetails.lblDob')}}
           <!--  <datepicker  :disabledDates="disabledDates"></datepicker> -->
        <date-picker confirm @change="dateValidation()" name="DOB" v-model="startTime" :option="option" :limit="limit" v-validate="'required'" :class="{'form-error': errors.has('DOB'),'input': true, 'is-danger': errors.collect('DOB') }" data-vv-name="DOB" data-vv-validate-on="change"  lang="en"></date-picker>   
          </div>
         <!--  <date-picker scroll="true" @change="dateValidation()" name="DOB" v-model="startTime" :option="option" :limit="limit" v-validate="'required'" :class="{'form-error': errors.has('DOB'),'input': true, 'is-danger': errors.collect('DOB') }" data-vv-name="DOB" data-vv-validate-on="change" ></date-picker> -->
          <sup>
            <i class="mdi mdi-star text-danger"></i>
          </sup>
          <div class="para"> {{$t('candidateProfile.personalDetails.lblMotherTongue')}} </div>
          <v-select label="name" :class="{'form-error': errors.has('mother Tongue')}" v-model="personalDetail.motherTongue" :options="motherTongueList" :error-messages="errors.collect('motherTongue')" v-validate="'required|not_in:Select'" data-vv-name="mother Tongue" name="motherTongue" :placeholder="$t('candidateProfile.personalDetails.plceHoMotherTongue')" required></v-select>
          <sup>
            <i class="mdi mdi-star text-danger"></i>
          </sup>
          <div class="para"> {{$t('candidateProfile.personalDetails.lblMotherTongueSpeak')}}</div>
          <br/>
          <div class="para"> {{$t('candidateProfile.personalDetails.lblMarritalStatus')}} </div>
          <v-select label="name" :class="{'form-error': errors.has('marital Status')}" v-model="personalDetail.maritalStatus" :options="maritalStatusList" :error-messages="errors.collect('maritalStatus')" v-validate="'required|not_in:Select'" data-vv-name="marital Status" name="maritalStatus" :placeholder="$t('candidateProfile.personalDetails.plceHoMaritalStatus')" required></v-select>
          <sup>
            <i class="mdi mdi-star text-danger"></i>
          </sup>
          <br/><br/><br/>
          <div class="para"> {{$t('candidateProfile.personalDetails.lblNameOnLeavingCertificate')}} </div>
          <input name="Name On Leaving Certificate" class="form-control-alt col-6 uppercase" id="namelc" v-model="personalDetail.nameOnLeavingCertificate" v-validate="'required|alpha_spaces'" :class="{'form-error': errors.has('form-1.Name On Leaving Certificate'),'input': true, 'is-danger': errors.has('form-1.Name On Leaving Certificate') }" type="text" :placeholder="$t('candidateProfile.personalDetails.plceHoNameOnCert')">
          <sup>
            <i class="mdi mdi-star text-danger"></i>
          </sup>
          <div class="para"> {{$t('candidateProfile.personalDetails.lblAadharNumber')}} </div>
          <input name="Aadhar Number" class="form-control-alt uppercase" id="aadhar" maxlength="12" v-model="personalDetail.aadhaarNumber" v-validate="'digits:12'" :class="{'form-error': errors.has('form-1.Aadhar Number'),'input': true, 'is-danger': errors.has('form-1.Aadhar Number') }" type="text" :placeholder="$t('candidateProfile.personalDetails.plceHoAadhaarNo')">
          <div class="para">
            <b>{{$t('candidateProfile.personalDetails.lblOr')}} &nbsp; &nbsp;</b> {{$t('candidateProfile.personalDetails.lblEnrolmentNumber')}} </div>
          <input name="Enrolment Number" class="form-control-alt uppercase" id="enrolment" maxlength="16" v-model="personalDetail.enrolmentNumber" v-validate="'alpha_num'" :class="{'form-error': errors.has('form-1.Enrolment Number'),'input': true, 'is-danger': errors.has('form-1.Enrolment Number') }" type="text" :placeholder="$t('candidateProfile.personalDetails.plceHoEnrolmentNo')">
          <sup>
            <i class="mdi mdi-star text-danger"></i>
          </sup>
          <div class="para"> {{$t('candidateProfile.personalDetails.lblPanNumber')}}</div>
          <input name="PAN Number" class="form-control-alt uppercase" id="panNo" maxlength="10" v-model="personalDetail.panNumber" :class="{'form-error': errors.has('form-1.PAN Number'),'input': true, 'is-danger': errors.has('form-1.PAN Number') }" type="text" :placeholder="$t('candidateProfile.personalDetails.plceHoPanNo')">
        </div>
      </div>
    </form>
    <div class=" row text-center p-3">
      <button type="button" class="btn btn btn-info-alt mr-3" @click="prevTabFunc"> {{$t('button.back')}}</button>
      <button type="button" class="btn btn btn-orange ml-auto" @click="nextTabFunc"> {{$t('button.next')}}</button>
    </div>
  </div>
</template>
<script>
import PictureInput from 'vue-picture-input'
/* import myDatepicker from 'vue-datepicker2' */
import myDatepicker from 'vue2-datepicker'
/* import datepicker from 'vuejs-datepicker' */
import axios from 'axios'
import moment from 'moment'
import xmlToJSON from 'xmltojson'
import validator from 'aadhaar-validator'
// import candidateProfile from '../../store/modules/candidateProfile';
export default {
  name: 'PersonalDetails',
  components: {
    PictureInput,
    'date-picker': myDatepicker
   /*  datepicker: datepicker */
  },
  data () {
    return {
      days: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
      months: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
      pickers: ['next 7 days', 'next 30 days', 'previous 7 days', 'previous 30 days'],
      placeholder: {
        date: 'Select Date',
        dateRange: 'Select Date Range'
      },
      start: new Date(1960, 2, 1),
      end: new Date(2001, 8, 1),
      startTime: '',
      scanAadhar: false,
      disabledDates: {
        to: new Date(2001, 8, 1),
        from: new Date(1960, 2, 1)
        /* daysOfMonth: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10] */
      },
      candidateProfile: { personalDetails: {}, contactDetails: {} },
      personalDetail: {},
      aadhaarData: {},
      aadhaarValid: false,
      genderList: [{ genderID: 1, name: 'Male' }, { genderID: 2, name: 'Female' }, { genderID: 3, name: 'Transgender' }],
      maritalStatusList: [
        { maritalStatusID: 1, name: 'Single' },
        { maritalStatusID: 2, name: 'Married' },
        { maritalStatusID: 3, name: 'Divorced' },
        { maritalStatusID: 4, name: 'Widowed' },
        { maritalStatusID: 5, name: 'Separated' }
      ],
      motherTongueList: [],
      drpDwn: false,
      endtime: {
        time: ''
      },
      date: {
        time: ''
      },
      limit: [
        {
          type: 'fromto',
          from: '1960-02-01',
          to: '2001-08-01'
        }
      ],
      option: {
        type: 'day',
        week: ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'],
        month: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
        format: 'YYYY-MM-DD',
        placeholder: 'Select Date Of Birth',
        inputStyle: {
          display: 'inline-block',
          padding: '6px',
          'line-height': '22px',
          'font-size': '16px',
          border: '2px solid #fff',
          'box-shadow': '0 1px 3px 0 rgba(0, 0, 0, 0.2)',
          'border-radius': '2px',
          color: '#5F5F5F'
        },
        color: {
          header: '#ccc',
          headerText: '#f00'
        },
        buttons: {
          ok: 'Ok',
          cancel: 'Cancel'
        },
        overlayOpacity: 0.5, // 0.5 as default
        dismissible: true // as true as default
      },
      timeoption: {
        type: 'min',
        week: ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'],
        month: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
        format: 'DD-MM-YYYY HH:mm'
      },
      multiOption: {
        type: 'multi-day',
        week: ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'],
        month: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
        format: 'DD-MM-YYYY HH:mm'
      }
    }
  },
  methods: {
    fetchUserDetails: function () {
      var self = this
      axios
        .get('/r/entry/getUserApplicationStatus/' + this.$store.state.candidateProfile.profileUser)
        .then(response => {
          if (response.data !== null) {
            let profileStatus = response.data.profileStatus
            if (!profileStatus.personalDetails) {
              this.$router.push({ name: 'personalDetails' })
            } else if (!profileStatus.contactDetails) {
              this.$router.push({ name: 'address' })
            } else if (!profileStatus.educationDetails) {
              this.$router.push({ name: 'educationalDetails' })
            } else if (!profileStatus.documentDetails) {
              this.$router.push({ name: 'documentsupload' })
            } else if (!profileStatus.qualificationDetails) {
              axios.get('r/projectConfig/getAllProjectConfig')
              .then(responses => {
                if (responses.data.ocrConfig.required) {
                  this.$router.push({ name: 'imageExtracter' })
                } else {
                  this.$router.push({ name: 'qualificationDetails' })
                }
              })
              .catch(e => {
                console.log(e)
              })
            } else {
              this.$router.push({ name: 'profileSummary' })
            }
          }
        })
        .catch(e => {
          this.$toasted.error(self.$t('toastr.toastrSomethingWentWrong'), {
            theme: 'bubble',
            duration: this.TOASTR_TIME
          })
          console.error(e)
        })
    },
    nextTabFunc () {
      if (
        (this.personalDetail.aadhaarNumber === undefined || this.personalDetail.aadhaarNumber === null || this.personalDetail.aadhaarNumber === '') &&
        (this.personalDetail.enrolmentNumber === undefined || this.personalDetail.enrolmentNumber === null || this.personalDetail.enrolmentNumber === '')
      ) {
        this.$toasted.error(this.$t('candidateProfile.personalDetails.toastrSelectAadharOrEnrolement'))
        return false
      } else if (this.personalDetail.aadhaarNumber !== undefined && this.personalDetail.aadhaarNumber !== null && this.personalDetail.aadhaarNumber !== '') {
        this.checkAadhaarValidity()
      } else {
        this.save()
      }
    },
    prevTabFunc () {
      this.$router.push('itCertification')
    },
    dateValidation () {
      axios
        .post('o/personalDetails/getvalidateDOBRoute', new Date(moment(String(this.startTime)).format('YYYY-MM-DD')))
        .then(response => {
          if (response.data === false) {
            this.startTime = ''
            this.$toasted.error(this.$t('candidateProfile.personalDetails.toastrNotValidDOB'))
          }
        })
        .catch(e => {
          console.error(e)
        })
    },
    async onInit (promise) {
      var self = this
      // show loading indicato
      try {
        await promise
        // successfully initialized
      } catch (error) {
        console.log(error)
        if (error.name === 'NotAllowedError') {
          // user denied camera access permisson
          // this.$toasted.error(self.$t('candidateProfile.personalDetails.toastrDeneidCameraAccess'), {
          this.$toasted.error(self.$t('candidateProfile.personalDetails.toastrNotSuitableCameraDevice'))
          this.scanAadhar = false
        } else if (error.name === 'NotFoundError') {
          // no suitable camera device installed
          this.$toasted.error(self.$t('candidateProfile.personalDetails.toastrNotSuitableCameraDevice'))
          this.scanAadhar = false
        } else if (error.name === 'NotSupportedError') {
          // page is not served over HTTPS (or localhost)
          // this.$toasted.error(self.$t('candidateProfile.personalDetails.toastrPageIsNotServed'), {
          this.$toasted.error(self.$t('candidateProfile.personalDetails.toastrNotSuitableCameraDevice'))
          this.scanAadhar = false
        } else if (error.name === 'NotReadableError') {
          // maybe camera is already in use
          // this.$toasted.error(self.$t('candidateProfile.personalDetails.toastrCameraAlereadyInUse'), {
          this.$toasted.error(self.$t('candidateProfile.personalDetails.toastrNotSuitableCameraDevice'))
          this.scanAadhar = false
        } else if (error.name === 'OverconstrainedError') {
          // passed constraints don't match any camera. Did you requested the front camera although there is none?
          // this.$toasted.error(self.$t('candidateProfile.personalDetails.toastrDontMatchAnyCamera'), {
          this.$toasted.error(self.$t('candidateProfile.personalDetails.toastrNotSuitableCameraDevice'))
          this.scanAadhar = false
        } else {
          // browser is probably lacking features (WebRTC, Canvas)
          // this.$toasted.error(self.$t('candidateProfile.personalDetails.toastrBrowserLackingFeatures'), {
          this.$toasted.error(self.$t('candidateProfile.personalDetails.toastrNotSuitableCameraDevice'))
          this.scanAadhar = false
        }
      } finally {
        // hide loading indicator
      }
    },
    onDecode (content) {
      content = content.slice(content.indexOf('?>') + 3, content.length)
      var result = xmlToJSON.parseString(content)
      this.personalDetail.aadhaarNumber = result.PrintLetterBarcodeData[0]._attr.uid._value.toString()
      this.aadhaarData.aadhaarNumber = result.PrintLetterBarcodeData[0]._attr.uid._value.toString()
      this.personalDetail.fullName = result.PrintLetterBarcodeData[0]._attr.name._value
      this.aadhaarData.fullName = result.PrintLetterBarcodeData[0]._attr.name._value
      if (result.PrintLetterBarcodeData[0]._attr.gender._value === 'M') {
        this.personalDetail.gender = { name: 'Male', genderID: 1 }
        this.aadhaarData.gender = { name: 'Male', genderID: 1 }
      } else if (result.PrintLetterBarcodeData[0]._attr.gender._value === 'F') {
        this.personalDetail.gender = { name: 'Female', genderID: 2 }
        this.aadhaarData.gender = { name: 'Female', genderID: 2 }
      } else {
        this.personalDetail.gender = { name: result.PrintLetterBarcodeData[0]._attr.gender._value }
        this.aadhaarData.gender = { name: result.PrintLetterBarcodeData[0]._attr.gender._value }
      }
      this.personalDetail.pincode = result.PrintLetterBarcodeData[0]._attr.pc._value
      this.candidateProfile.personalDetails = JSON.parse(JSON.stringify(this.personalDetail))
      this.candidateProfile.aadhaarVerified = true
      this.$toasted.success(this.$t('toastr.toastrAadhaarScanSuccess'), {
        theme: 'bubble',
        duration: 2000
      })
    },
    getAllData: function () {
      // Get Mother Tongue List.
      axios
        .get('r/personalDetails/getMotherTongueListRoute')
        .then(response => {
          this.motherTongueList = response.data
          this.getPersonalDetails()
        })
        .catch(e => {
          console.error(e)
        })
    },
    getPersonalDetails () {
      // Get Personal Details.
      axios
        .get('r/personalDetails/getPersonalDetailsRoute/' + this.$store.state.candidateProfile.profileUser)
        .then(response => {
          var responseData = response.data
          if (responseData !== null && responseData !== '') {
            // console.log('fullName' + JSON.stringify(response.data.fullName))
            this.candidateProfile = responseData
            if (this.candidateProfile.aadhaarVerified === true) {
              this.aadhaarData.fullName = this.candidateProfile.personalDetails.fullName
              this.aadhaarData.gender = this.candidateProfile.personalDetails.gender
              this.aadhaarData.aadhaarNumber = this.candidateProfile.personalDetails.aadhaarNumber
            }
            this.personalDetail = JSON.parse(JSON.stringify(this.candidateProfile.personalDetails))

            if (this.personalDetail.gender.genderID === 0) {
              delete this.personalDetail.gender
              delete this.personalDetail.maritalStatus
              delete this.personalDetail.motherTongue
            }
            if (this.personalDetail.dob !== undefined && this.personalDetail.dob !== null && this.personalDetail.dob !== '') {
              this.startTime = moment(String(this.personalDetail.dob)).format('YYYY-MM-DD')
            }
          }
        })
        .catch(e => {
          console.error(e)
        })
    },
    checkAadhaarValidity: function () {
      var self = this
      if (this.validateAadhaar()) {
        axios
          .get('r/personalDetails/validateaadhaarduplication/' + this.$store.state.candidateProfile.profileUser + '/' + this.personalDetail.aadhaarNumber)
          .then(response => {
            var aadhaaValid = response.data
            if (!aadhaaValid) {
              this.aadhaarValid = false
              this.$toasted.error(self.$t('candidateProfile.personalDetails.toastrAadhaarAlreadyExists'))
            } else {
              this.aadhaarValid = true
              this.save()
            }
          })
          .catch(e => {
            console.error(e)
          })
      } else {
        this.$toasted.error(self.$t('candidateProfile.personalDetails.toastrEnterValidAadhaarDetails'))
        return false
      }
    },
    validateAadhaar: function () {
      return validator.isValidNumber(this.personalDetail.aadhaarNumber.toString())
    },
    validatePanNumber: function () {
      var panPat = /^([a-zA-Z]{5})(\d{4})([a-zA-Z]{1})$/
      var code = /([C,P,H,F,A,T,B,L,J,G])/
      var panSubString = this.personalDetail.panNumber.substring(3, 4)
      if (this.personalDetail.panNumber.search(panPat) === -1) {
        return false
      }
      if (code.test(panSubString) === false) {
        return false
      }
      return true
    },
    save: function (scope) {
      // This method save personal details in candidate_profile collection(mongoDB).
      this.personalDetail.fullName = this.personalDetail.fullName.toUpperCase()
      this.personalDetail.nameOnLeavingCertificate = this.personalDetail.nameOnLeavingCertificate.toUpperCase()
      if (this.personalDetail.panNumber) {
        this.personalDetail.panNumber = this.personalDetail.panNumber.toUpperCase()
      }
      var self = this
      return this.$validator
        .validate()
        .then(result => {
          if (result) {
            /* if (this.aadhaarValid === false) {
              this.checkAadhaarValidity()
              return false
            } */
            if (this.personalDetail.panNumber !== undefined && this.personalDetail.panNumber !== null && this.personalDetail.panNumber !== '') {
              if (!this.validatePanNumber()) {
                this.$toasted.error(self.$t('candidateProfile.personalDetails.toastrEnterValidPanDetails'))
                return false
              }
            }
            if (this.aadhaarData.fullName !== undefined && this.aadhaarData.fullName !== null && this.aadhaarData.fullName !== '') {
              if (this.aadhaarData.fullName !== this.personalDetail.fullName) {
                this.candidateProfile.aadhaarVerified = false
                this.candidateProfile.personalDetails.fullName = this.personalDetail.fullName
              }
              if (this.aadhaarData.gender.genderID !== this.personalDetail.gender.genderID) {
                this.candidateProfile.aadhaarVerified = false
                this.candidateProfile.personalDetails.gender.genderID = this.personalDetail.gender.genderID
              }
              if (this.aadhaarData.aadhaarNumber !== this.personalDetail.aadhaarNumber) {
                this.candidateProfile.aadhaarVerified = false
                this.candidateProfile.personalDetails.aadhaarNumber = this.personalDetail.aadhaarNumber
              }
              if (this.personalDetail.pincode !== undefined && this.personalDetail.pincode !== null && this.personalDetail.pincode !== '') {
                this.candidateProfile.contactDetails.permanentPin = this.personalDetail.pincode
              }
            } else {
              this.candidateProfile.aadhaarVerified = false
            }
            if (this.personalDetail.panNumber !== undefined && this.personalDetail.panNumber !== null && this.personalDetail.panNumber !== '') {
              this.candidateProfile.personalDetails.panNumber = this.personalDetail.panNumber.toUpperCase()
            }
            this.candidateProfile.personalDetails = this.personalDetail
            this.candidateProfile.personalDetails.dob = new Date(moment(String(this.startTime)).format('YYYY-MM-DD'))
            this.candidateProfile.personalDetails.fullName = this.candidateProfile.personalDetails.fullName.trim()
            this.candidateProfile.personalDetails.nameOnLeavingCertificate = this.candidateProfile.personalDetails.nameOnLeavingCertificate.trim()
            return axios
              .post('r/personalDetails/updatepersonalDetails/' + this.$store.state.candidateProfile.profileUser, this.candidateProfile)
              .then(response => {
                if (response.status === 200) {
                  this.$toasted.success(self.$t('toastr.toastrPersonalDetailsSaved'))
                  this.scanAadhar = false
                  // this.$router.push('address')
                  this.fetchUserDetails()
                  return true
                }
              })
              .catch(e => {
                console.log(e)
                return false
              })
          } else {
            this.$validator.validate('form-1.FullName', this.personalDetail.fullName).then(result => {
              if (!result) {
                this.$toasted.error(self.$t('candidateProfile.personalDetails.toastrEnterValidFullName'))
              }
            })
            this.$validator.validate('form-1.Father Name', this.personalDetail.fatherName).then(result => {
              if (!result) {
                this.$toasted.error(self.$t('candidateProfile.personalDetails.toastrEnterFatherName'))
              }
            })
            this.$validator.validate('form-1.Mother Name', this.personalDetail.motherName).then(result => {
              if (!result) {
                this.$toasted.error(self.$t('candidateProfile.personalDetails.toastrEnterMotherName'))
              }
            })
            this.$validator.validate('gender', this.personalDetail.gender).then(result => {
              if (!result) {
                this.$toasted.error(self.$t('candidateProfile.personalDetails.toastrSelectGender'))
              }
            })
            this.$validator.validate('DOB', this.personalDetail.dob).then(result => {
              if (!result) {
                this.$toasted.error(self.$t('candidateProfile.personalDetails.toastrEnterValidDOB'))
              }
            })
            this.$validator.validate('mother Tongue', this.personalDetail.motherTongue).then(result => {
              if (!result) {
                this.$toasted.error(self.$t('candidateProfile.personalDetails.toastrSelectMotherTongue'))
              }
            })
            this.$validator.validate('marital Status', this.personalDetail.maritalStatus).then(result => {
              if (!result) {
                this.$toasted.error(self.$t('candidateProfile.personalDetails.toastrSelectMaritalStatus'))
              }
            })
            this.$validator.validate('form-1.Name On Leaving Certificate', this.personalDetail.nameOnLeavingCertificate).then(result => {
              if (!result) {
                this.$toasted.error(self.$t('candidateProfile.personalDetails.toastrEnterNameOnLeavingCertificate'))
              }
            })
            this.$validator.validate('form-1.Aadhar Number', this.personalDetail.aadhaarNumber).then(result => {
              if (!result) {
                if (this.personalDetail.aadhaarNumber === '') {
                  this.$toasted.error(self.$t('candidateProfile.personalDetails.toastrEnterAadhaarDetails'))
                } else {
                  this.$toasted.error(self.$t('candidateProfile.personalDetails.toastrAadhaarMustBe12Digits'))
                }
              }
            })
            return false
          }
        })
        .catch(e => {
          console.error(e)
          return false
        })
    }
  },
  created: function () {
    if (this.$store.state.user.userDetails.confirmStatus) {
      this.$router.push({ name: 'entry' })
    } else {
      this.getAllData()
      this.getPersonalDetails()
    }
  },
  beforeDestroy: function () {
    this.scanAadhar = false
  }
}
</script>
<style lang='scss'>
.p-details {
  .qrcode-reader__camera {
    // border-radius:4px;
    display: inline-block;
    //  height: 100%;
    width: 50%;
    border-radius: 5px;
  }
  .qrClass {
    height: 100%;
    // width: 100% ;
  }
  .uppercase {
    text-transform: uppercase;
  }
}
.pad-left-35 {
  padding-left: 35px !important ;
}
.mx-input {
      display: inline-block;
    width: 100%;
    height: 34px;
    padding: 6px 30px 6px 10px;
    font-size: 14px;
    line-height: 1.4;
    color: #555;
    background-color: #fff;
    border: 1px solid #ccc;
    border-radius: 4px;
    border-top: 0px;
    border-left: 0px;
    border-right: 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/registration/personalDetails.vue